















































































import { AuthNavigationVueSNB } from "@/extensions/navigation/AuthNavigationVueSNB";
import { Component } from "vue-property-decorator";

@Component()
export default class AuthNavigation extends AuthNavigationVueSNB {
  get windowHref(): string {
    return this.$route.path;
  }

  get appVersion(): string {
     return process.env.VUE_APP_VERSION
  }
  openModal() {
    this.isModalOpen = true;
  }
}
